import React from 'react';
import styled, { withTheme } from 'styled-components'

const Name = styled.h2`
    color:#FFF;
    text-transform: uppercase;
    font-size:1em;
    margin-bottom: -10px;
`
const Description = styled.p`
    color:#FFF;
    font-Family: ${props => props.theme.fonts.text};
    font-weight: 400;
    font-size:.75em;
`
const TextContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
`
const Image = styled.div`
    display: inline-block;
    vertical-align: middle;
    width:62px;
    img{
        width:100%;
    }
`

const AuthorBadge = (props) => {
    return (
        <div>
            <Image>
                <img src={require('../../../../../assets/img/bg/author@2x.png').default} alt={props.authorImageAlt}></img>
            </Image>
            <TextContainer>
                <Name>Siddhartha Joshi</Name>
                <Description>{"Adventurer & storyteller"}</Description>
            </TextContainer>
        </div>
    );
};

export default withTheme(AuthorBadge);